import React, { useEffect, useState } from 'react';
import { apiCall, userHasRole } from '../../utils';
const XLSX = require('xlsx');


const BranchFinancialOverview = ({
  isTabOpen = false, 
  branchId, 
  branch,
  filterData,
  currentXhr,
  setCurrentXhr
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState({
    table1: []
  })
  const [tableTotals, setTableTotals] = useState({
    table1: {
      PN: 0,
      PIT: 0,
      PIM: 0,
    }
  })
  const [branchIdx, setBranchIdx] = useState(-1);
  const [isWaitingForApi, setIsWaitingForApi] = useState(false);
  const [disabledGoalUpdate, setDisabledGoalUpdate] = useState(true);
  const [branchCurrentGoal, setBranchCurrentGoal] = useState(0);

  const fetchFinancialReports = async (branch) => {
    if (currentXhr) {
      currentXhr.abort();
      setCurrentXhr(false);
    }
    let xhr = apiCall({
      method: 'GET',
      endpoint: 'api/v1/reports/financial',
      data: {
        branch: branchId,
        startDate: filterData.startDate,
        endDate: filterData.endDate,
        reportType: 'FINANCIAL_OVERVIEW'
      },
      successCallback: function(res) {
        setIsLoading(false);
        setCurrentXhr(false);
        window.toast({
          error: res.error,
          text: res.message
        })
        if (res.error) {
        } else {
          //console.log('res', res);
          setTableData({
            table1: res
          });
          setBranchCurrentGoal(res.data_contaazul[0].META_FATURAMENTO_VALOR);
          setBranchIdx(res.data_contaazul[0].FILIAL_ID);
        }
      },
      errorCallback: function(res) {
        setIsLoading(false);
        setCurrentXhr(false);
      }
    });
    setCurrentXhr(xhr);
  }

  //console.log('tableData.table1', tableData.table1);

  const handleGoalUpdate = (e) => {
    let newValue = e.target.value;
    if (newValue === '') {
      newValue = 0;
    }
    if (newValue !== branchCurrentGoal) {
      setDisabledGoalUpdate(false);
    } else {
      setDisabledGoalUpdate(true);
    }
    setBranchCurrentGoal(e.target.value);
  }

  const submitGoalUpdate = () => {
    setIsWaitingForApi(true);
    apiCall({
      method: 'PUT',
      endpoint: 'api/v1/business/branch_goal',
      data: {
        branchId: branchId,
        meta: branchCurrentGoal,
      },
      successCallback: function(res) {
        window.toast({
          error: res.error,
          text: res.message
        })
        setIsWaitingForApi(false);
        setDisabledGoalUpdate(true);
      },
      errorCallback: function(res) {
        setIsWaitingForApi(false);
      }
    });
  }

  const exportToExcel = () => {
    // html
    const tbl1 = document.getElementById("table-financial-overview-by-branch");
    const worksheet = XLSX.utils.table_to_sheet(tbl1);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'relatorio_financeiro_unidade_'+branch+'_'+window.getSaoPauloDateTime()+'.xlsx');
    window.toast({
      error: false,
      text: "Exportação realizada com sucesso."
    })
  }

  const exportJsPdf = () => {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    // Extract table
    doc.autoTable({
        html: '#table-financial-overview-by-branch'
    });

    // Save the PDF
    doc.save('relatorio_financeiro_unidade_'+branch+'_'+window.getSaoPauloDateTime()+'.pdf');
  }


  useEffect(() => {
    if (isTabOpen) {
      setIsLoading(true);
      //console.log('render called for branch overview', branch)
      if (filterData.startDate && filterData.endDate) {
        //if (!currentXhr) {
          setTableData({
            table1: []
          });
          fetchFinancialReports(branch)
        //}
      }
    } else {
      setIsLoading(true);
      //console.log('cleanup called for branch overview', branch)
    }
  }, [isTabOpen, filterData]);

  /*useEffect(() => {
    //console.log('isTabOpen', isTabOpen);
    if (isTabOpen && filterData.startDate && filterData.endDate) {
      setTableData({
        table1: []
      });
      fetchFinancialReports();
    }
  }, [filterData]);*/

  useEffect(() => {
    //console.log('tableData', tableData);

    if (tableData?.table1?.data_contaazul) {
      let totalPN = 0;
      let totalPIT = 0;
      let totalPIM = 0;
      let metaAlcancada = 0;
      let totalSessoes = 0;
      let totalFaturamento = 0;
      let ticketMedioPorSessao = 0;
      let ticketMedioReais = 0;
      let aproveitamentoPitPn = 0;

      let mediaPnTotal = 0;
      let mediaPnTotalCount = 0;

      tableData.table1.data_contaazul.map((row) => {
        totalPN += row.PN;
        totalPIT += row.PIT;
        totalPIM += row.PIM;
        totalFaturamento += row.FATURAMENTO_ATE_HOJE;
        totalSessoes += row.SESSOES_VENDIDAS;
        metaAlcancada = parseFloat(row.META_FATURAMENTO_PORCENTAGEM);

        ticketMedioReais += parseFloat(row.TICKET_MEDIO);
        mediaPnTotal += parseFloat(row.MEDIA_PNS_POR_DIA);
        mediaPnTotalCount++;
      });

      metaAlcancada = metaAlcancada / tableData.table1.data_contaazul.length;
      aproveitamentoPitPn = totalPN == 0 ? 0 : totalPIT * 100 / totalPN;
      ticketMedioPorSessao = totalSessoes == 0 ? 0 : totalFaturamento / totalSessoes;
      ticketMedioReais = ticketMedioReais / tableData.table1.data_contaazul.length;

      setTableTotals({
        table1: {
          PN: totalPN,
          PIT: totalPIT,
          PIM: totalPIM,
          APROVEITAMENTO: parseFloat(aproveitamentoPitPn).toFixed(2),
          META_PORCENTAGEM: parseFloat(metaAlcancada).toFixed(2),
          TICKET_MEDIO_POR_SESSAO: parseFloat(ticketMedioPorSessao).toFixed(2),
          TICKET_MEDIO: parseFloat(ticketMedioReais).toFixed(2),
          TOTAL_FATURAMENTO: parseFloat(totalFaturamento).toFixed(2),
          TOTAL_SESSOES: totalSessoes,
          MEDIA_PNS_POR_DIA: mediaPnTotalCount > 0 ? parseFloat(mediaPnTotal / mediaPnTotalCount).toFixed(2) : 0
        }
      });
    }
  }, [tableData]);

  return (
    <>
      <div className="p-2">
        <h6>Relatório Financeiro e Desempenho da Unidade de {branch} ({branchId})</h6>
        {isLoading && (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        )}
        {!isLoading && tableData?.table1?.data_contaazul && (
          <>
            <div className="d-flex justify-content-end">
              <button type='button' className="btn btn-primary mt-3 mb-3" onClick={(e) => exportToExcel()}>Exportar para Excel</button>
              <button type='button' className="btn btn-primary mt-3 ml-2 mb-3" onClick={(e) => exportJsPdf()}>Exportar para PDF</button>
            </div>
            Meta atual: {!userHasRole('ADMIN') ? branchCurrentGoal : <input type="number" className="form-control" value={branchCurrentGoal} onChange={(e) => handleGoalUpdate(e)} />}
            {userHasRole('ADMIN') && <button type='button' className="btn btn-primary mt-3 mb-3" disabled={disabledGoalUpdate || isWaitingForApi} onClick={(e) => submitGoalUpdate()}>Atualizar Meta</button>}
            <table id="table-financial-overview-by-branch" className="mb-0 table table-bordered table-striped table-hover responsive-table">
              <tbody className="text-center">
                {tableData.table1.data_contaazul.map((row, index) => {
                  return (
                    <>
                      <tr key={`row-${index}`}>
                        <td>FATURAMENTO<br />R${row.FATURAMENTO_ATE_HOJE}</td>
                        <td>TICKET POR SESSÃO<br />R${row.TICKET_MEDIO_POR_SESSAO}</td>
                        <td>TICKET R$<br />R${tableTotals.table1.TICKET_MEDIO}</td>
                        <td>META %<br />{row.META_FATURAMENTO_VALOR == 0 ? 0 : parseFloat(row.FATURAMENTO_ATE_HOJE * 100 / row.META_FATURAMENTO_VALOR).toFixed(2)}%</td>
                        <td>CANCELAMENTOS<br />0</td>
                      </tr>
                      <tr key={`row-2-${index}`}>
                        <td>PN<br />{row.PN}</td>
                        <td>PIT<br />{row.PIT}</td>
                        <td>PIM<br />{row.PIM}</td>
                        <td>SESSÕES<br />{row.SESSOES_VENDIDAS}</td>
                        <td>APROVEITAMENTO PITxPIM<br />{row.PN == 0 ? 0 : parseFloat(row.PIT * 100 / row.PN).toFixed(2)}%</td>
                      </tr>
                      <tr key={`row-3-${index}`}>
                        <td>META<br />R${row.META_FATURAMENTO_VALOR}</td>
                        <td>CANCELAMENTOS<br />-</td>
                        <td>PROJEÇÃO META<br />{row.PROJECAO_META}%</td>
                        <td>PROJEÇÃO FAT.<br />R${row.PROJECAO_MENSAL}</td>
                      </tr>
                    </>
                  )
                })}
              </tbody>
            </table>
          </>
        )}
      </div>
    </>
  );
}
export default BranchFinancialOverview;